import React from 'react'

const CheckBox = ({label, children, value, onChange, labelClassName}) => {
  const text = children ? children : label
  return <label className={labelClassName ? labelClassName : ""}>
    <input type="checkbox" checked={value} onChange={_=>onChange(!value)}/>
    {' '}
    {text}
  </label>
}
export default CheckBox



/** WEBPACK FOOTER **
 ** ./app/components/CheckBox.jsx
 **/